function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { branch, compose, withPropsOnChange, withStateHandlers, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import { capitalizeHyphenated } from '@applyboard/ui-utils';
import { formatDateLocal } from "../../../../util/datetime";
import componentErrorBoundary from "../../../../components/enhancers/componentErrorBoundary";
var enhancer = compose(componentErrorBoundary, withPropsOnChange(['stageActive', 'stageName', 'requirements', 'userPermissions', 'tab'], function (_ref) {
  var stageActive = _ref.stageActive,
    stageName = _ref.stageName,
    requirements = _ref.requirements,
    userPermissions = _ref.userPermissions,
    tab = _ref.tab;
  var stageEmpty = !requirements || requirements.length <= 0;
  var displayStageName = stageName === 'visa-application' ? 'Visa Application' : capitalizeHyphenated(stageName);
  if (tab !== 'actions' && (userPermissions.create_requirement_with_template || userPermissions.create_requirement_without_template) && (!stageActive || stageEmpty)) {
    displayStageName += ' (Visible to Admin Only)';
  }
  var statusCounts = {
    missing: 0,
    reviewing: 0,
    not_approved: 0,
    completed: 0,
    no_status: 0
  };
  var stageSubtitle;
  if (!stageEmpty && stageActive) {
    requirements.forEach(function (req) {
      if (req.required_state === 'required_state_required') {
        statusCounts[req.status.split('status_')[1]] += 1;
      }
    });
    var lastUpdatedRequirementDate = getLastUpdatedRequirementDate(requirements);
    var numReqToBeCompleted = 0;
    for (var status in statusCounts) {
      if (status !== 'completed' && status !== 'no_status') {
        numReqToBeCompleted += statusCounts[status];
      }
    }
    stageSubtitle = numReqToBeCompleted > 0 || statusCounts.completed == 0 ? "".concat(numReqToBeCompleted, " requirements to be completed") : "Last requirement completed on ".concat(lastUpdatedRequirementDate);
  } else {
    stageSubtitle = '0 requirements to be completed';
  }
  return {
    displayStageName: displayStageName,
    statusCounts: statusCounts,
    stageSubtitle: stageSubtitle
  };
}), branch(function (_ref2) {
  var stageEmpty = _ref2.stageEmpty;
  return !stageEmpty;
}, withStateHandlers({
  expanded: true
}, {
  toggleExpand: function toggleExpand(_ref3) {
    var expanded = _ref3.expanded;
    return function () {
      return {
        expanded: !expanded
      };
    };
  }
})), setPropTypes({
  displayStageName: PropTypes.string.isRequired,
  stageSubtitle: PropTypes.string,
  expanded: PropTypes.bool,
  requirements: PropTypes.array,
  toggleExpand: PropTypes.func,
  preview: PropTypes.bool,
  onEditRequirement: PropTypes.func,
  stageName: PropTypes.string,
  statusCounts: PropTypes.object,
  highlightedRequirementId: PropTypes.string
}));
function getLastUpdatedRequirementDate(requirements) {
  var attachments = requirements.filter(function (requirement) {
    var _requirement$attachme;
    return (_requirement$attachme = requirement.attachments) === null || _requirement$attachme === void 0 ? void 0 : _requirement$attachme.length;
  }).flatMap(function (requirement) {
    return requirement.attachments;
  });
  var questions = requirements.filter(function (requirement) {
    var _requirement$applicat;
    return (_requirement$applicat = requirement.application_questions) === null || _requirement$applicat === void 0 ? void 0 : _requirement$applicat.length;
  }).flatMap(function (requirement) {
    return requirement.application_questions;
  });
  var disclaimers = requirements.filter(function (requirement) {
    return requirement.requirement_template_type === 'disclaimer' && requirement.status === 'status_completed';
  });
  var updatedAtDates = [].concat(_toConsumableArray(attachments.map(function (attachment) {
    return new Date(attachment.updatedAt);
  })), _toConsumableArray(questions.map(function (question) {
    return new Date(question.updated_at);
  })), _toConsumableArray(disclaimers.map(function (disclaimer) {
    return new Date(disclaimer.updated_at);
  })));
  return updatedAtDates.length > 0 ? formatDateLocal(new Date(Math.max.apply(Math, _toConsumableArray(updatedAtDates))), 'MMM. DD, YYYY') : 'Not available';
}
export default enhancer;